// extracted by css-extract-rspack-plugin
export default {"cls1":"Modal-cls1_s3H","cls2":"Modal-cls2_cAe Modal-cls1_s3H"};